"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_ITEM_STYLING = exports.MENU_ITEM_STYLING_BUTTON = exports.MENU_ITEM_STYLING_LINK = exports.MENU_ITEM_TYPE = exports.DEFAULT_MENU_ITEM = exports.DEFAULT_MENU_TYPES = exports.MENU_ELEMENT_TYPE = exports.MENU_ELEMENT_TYPES = exports.MENU_ITEM_TYPES = exports.useAPIContext = exports.BaseAPI = void 0;
exports.EventAPIProvider = EventAPIProvider;
const EventAPIContext_1 = __importStar(require("./api/context/EventAPIContext"));
/* eslint-disable prefer-arrow/prefer-arrow-functions */
const react_1 = __importStar(require("react"));
const event_1 = require("./api/event");
const posts_1 = require("./api/posts");
// index.ts
const attendee_1 = require("./api/attendee");
const authentication_1 = require("./api/authentication");
const calendar_1 = require("./api/calendar");
const meetings_1 = require("./api/meetings");
const public_1 = require("./api/public");
const sessions_1 = require("./api/sessions");
const tracks_1 = require("./api/tracks");
const pages_1 = require("./api/pages");
const api_1 = require("./utils/api");
const hooks_1 = require("./utils/hooks");
function EventAPIProvider(props) {
    const [config, setConfig] = (0, hooks_1.useSetState)({});
    const init = react_1.default.useCallback((baseUrl, email, password) => __awaiter(this, void 0, void 0, function* () {
        try {
            const { token } = yield (0, authentication_1._login)(baseUrl, email, password);
            if (token) {
                setConfig({ token, baseUrl });
            }
            return token;
        }
        catch (_a) {
            throw Error("Login Failed");
        }
    }), []);
    const initWithToken = react_1.default.useCallback((baseUrl, token) => {
        if (!token || !baseUrl) {
            return false;
        }
        setConfig({ token, baseUrl });
        return true;
    }, [config]);
    const initWithoutToken = react_1.default.useCallback((baseUrl) => {
        if (!baseUrl) {
            return false;
        }
        setConfig({ baseUrl });
        return true;
    }, [config]);
    const fetchEventRegistrations = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const eventRegistrations = yield (0, event_1._fetchEventRegistrations)(config.baseUrl, config.token, eventId);
        return eventRegistrations;
    }), [config, config.baseUrl, config.token]);
    const fetchExhibitions = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const exhibitions = yield (0, event_1._fetchExhibitions)(config.baseUrl, config.token, eventId);
        return exhibitions;
    }), [config, config.baseUrl, config.token]);
    const fetchEventDetails = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const eventDetails = yield (0, event_1._fetchEventDetails)(config.baseUrl, config.token, eventId);
        return eventDetails;
    }), [config, config.baseUrl, config.token]);
    const fetchExhibitionDetails = react_1.default.useCallback((exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const eventDetails = yield (0, event_1._fetchExhibitionDetails)(config.baseUrl, config.token, exhibitionId);
        return eventDetails;
    }), [config, config.baseUrl, config.token]);
    const fetchEventLocations = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const eventLocations = yield (0, event_1._fetchEventLocations)(config.baseUrl, config.token, eventId);
        return eventLocations;
    }), [config, config.baseUrl, config.token]);
    const fetchEventStreams = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const eventStreams = yield (0, event_1._fetchEventStreams)(config.baseUrl, config.token, eventId);
        return eventStreams;
    }), [config, config.baseUrl, config.token]);
    const fetchUserRegistrationsEvents = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const registrations = yield (0, event_1._fetchUserRegistrationsEvents)(config.baseUrl, config.token);
        return registrations;
    }), [config, config.baseUrl, config.token]);
    const fetchEventDocuments = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        const documents = yield (0, event_1._fetchEventDocuments)(config.baseUrl, config.token, eventId);
        return documents;
    }), [config, config.baseUrl, config.token]);
    const reportExhibitionAction = react_1.default.useCallback((exhibitionId, requestData) => {
        (0, api_1.validateConfig)(config);
        void (0, event_1._reportExhibitionAction)(config.baseUrl, config.token, exhibitionId, requestData);
    }, [config, config.baseUrl, config.token]);
    const pinDocument = react_1.default.useCallback((eventId, exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._pinDocument)(config.baseUrl, config.token, eventId, exhibitionId);
    }), [config, config.baseUrl, config.token]);
    const pinExhibition = react_1.default.useCallback((exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._pinExhibition)(config.baseUrl, config.token, exhibitionId);
    }), [config, config.baseUrl, config.token]);
    const unpinExhibition = react_1.default.useCallback((exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._unpinExhibition)(config.baseUrl, config.token, exhibitionId);
    }), [config, config.baseUrl, config.token]);
    const unpinDocument = react_1.default.useCallback((eventId, exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._unpinDocument)(config.baseUrl, config.token, eventId, exhibitionId);
    }), [config, config.baseUrl, config.token]);
    const fetchEventGroups = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventGroups)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchPublicEventGroups = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchPublicEventGroups)(config.baseUrl, eventId);
    }), [config, config.baseUrl, config.token]);
    const deleteMediaDirectories = (0, react_1.useCallback)((accountId, path, name) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteMediaDirectories)(config.baseUrl, config.token, accountId, path, name);
    }), [config, config.baseUrl, config.token]);
    const addMediaFolder = (0, react_1.useCallback)((accountId, path, name) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._addMediaFolder)(config.baseUrl, config.token, accountId, path, name);
    }), [config, config.baseUrl, config.token]);
    const updateEventWebsite = (0, react_1.useCallback)((eventId, keyData, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventWebsite)(config.baseUrl, config.token, eventId, keyData, data, files);
    }), [config, config.baseUrl, config.token]);
    const deleteMediaDirectoryFiles = (0, react_1.useCallback)((accountId, filepath) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteMediaDirectoryFiles)(config.baseUrl, config.token, accountId, filepath);
    }), [config, config.baseUrl, config.token]);
    const updateAccountGroup = (0, react_1.useCallback)((accountId, groupId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._updateAccountGroup)(config.baseUrl, config.token, accountId, groupId, data);
    }), [config, config.baseUrl, config.token]);
    const updateVisibilityAttendee = (0, react_1.useCallback)((attendeeId, visibility) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateVisibilityAttendee)(config.baseUrl, config.token, attendeeId, visibility);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountGroups = (0, react_1.useCallback)((accountId, type) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchAccountGroups)(config.baseUrl, config.token, accountId, type);
    }), [config, config.baseUrl, config.token]);
    const createAccountGroup = (0, react_1.useCallback)((accountId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._createAccountGroup)(config.baseUrl, config.token, accountId, body);
    }), [config, config.baseUrl, config.token]);
    const fetchEventAttendeeActions = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventAttendeeActions)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountBookings = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAccountBookings)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountDocuments = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAccountDocuments)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountProfiles = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAccountProfiles)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const createOffer = (0, react_1.useCallback)((accountId, body, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createOffer)(config.baseUrl, config.token, accountId, body, files);
    }), [config, config.baseUrl, config.token]);
    const fetchOffers = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchOffers)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const fetchOfferDetails = (0, react_1.useCallback)((accountId, offerId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchOfferDetails)(config.baseUrl, config.token, accountId, offerId);
    }), [config, config.baseUrl, config.token]);
    const updateOffer = (0, react_1.useCallback)((accountId, offerId, body, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateOffer)(config.baseUrl, config.token, accountId, offerId, body, files);
    }), [config, config.baseUrl, config.token]);
    const sendOffer = (0, react_1.useCallback)((accountId, offerId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._sendOffer)(config.baseUrl, config.token, accountId, offerId);
    }), [config, config.baseUrl, config.token]);
    const approveOffer = (0, react_1.useCallback)((accountId, offerId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._approveOffer)(config.baseUrl, config.token, accountId, offerId);
    }), [config, config.baseUrl, config.token]);
    const createTestimonial = (0, react_1.useCallback)((eventId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createTestimonial)(config.baseUrl, config.token, eventId, data, files);
    }), [config, config.baseUrl, config.token]);
    const updateTestimonial = (0, react_1.useCallback)((eventId, testimonialId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateTestimonial)(config.baseUrl, config.token, eventId, testimonialId, data, files);
    }), [config, config.baseUrl, config.token]);
    const createStatistic = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createStatistic)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateStatistic = (0, react_1.useCallback)((eventId, statisticId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateStatistic)(config.baseUrl, config.token, eventId, statisticId, data);
    }), [config, config.baseUrl, config.token]);
    const createKeyTopic = (0, react_1.useCallback)((eventId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createKeyTopic)(config.baseUrl, config.token, eventId, data, files);
    }), [config, config.baseUrl, config.token]);
    const updateKeyTopic = (0, react_1.useCallback)((eventId, keyTopicId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateKeyTopic)(config.baseUrl, config.token, eventId, keyTopicId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventTargetGroups = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventTargetGroups)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventCitations = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventCitations)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventSurveys = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventSurveys)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventTickets = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventTickets)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventFaqs = (0, react_1.useCallback)((eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventFaqs)(config.baseUrl, config.token, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const updateEventSpeakerAdverts = (0, react_1.useCallback)((eventId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventSpeakerAdverts)(config.baseUrl, config.token, eventId, data, files);
    }), [config, config.baseUrl, config.token]);
    const resendTicketEmail = react_1.default.useCallback((ticketId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._resendTicketEmail)(config.baseUrl, config.token, ticketId);
    }), [config, config.baseUrl, config.token]);
    const resendBookingEmail = (0, react_1.useCallback)((bookingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._resendBookingEmail)(config.baseUrl, config.token, bookingId);
    }), [config, config.baseUrl, config.token]);
    const postTicketDetails = (0, react_1.useCallback)((eventId, profileId, access, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._postTicketDetails)(config.baseUrl, eventId, profileId, access, body);
    }), [config, config.baseUrl, config.token]);
    const confirmAttendee = (0, react_1.useCallback)((attendeeId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._confirmAttendee)(config.baseUrl, config.token, attendeeId, data);
    }), [config, config.baseUrl, config.token]);
    const checkBooking = (0, react_1.useCallback)((body, lang) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._checkBooking)(config.baseUrl, body, lang);
    }), [config, config.baseUrl, config.token]);
    const createBooking = (0, react_1.useCallback)((body, lang) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createBooking)(config.baseUrl, body, lang);
    }), [config, config.baseUrl, config.token]);
    const fetchEventOrderedTickets = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventOrderedTickets)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const acceptInternTicket = (0, react_1.useCallback)((ticketId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._acceptInternTicket)(config.baseUrl, config.token, ticketId, body);
    }), [config, config.baseUrl, config.token]);
    const fetchTickets = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchTickets)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const getPublicRegistrationForm = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, public_1._getPublicRegistrationForm)(config.baseUrl, eventId);
    }), [config, config.baseUrl]);
    const getPublicGroupDetails = (0, react_1.useCallback)((groupId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, public_1._getPublicGroupDetails)(config.baseUrl, groupId);
    }), [config, config.baseUrl]);
    const fetchMyBookings = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMyBookings)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const assignTicket = (0, react_1.useCallback)((bookingId, ticketId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._assignTicket)(config.baseUrl, config.token, bookingId, ticketId, data);
    }), [config, config.baseUrl, config.token]);
    const acceptTicket = (0, react_1.useCallback)((ticketId, access, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._acceptTicket)(config.baseUrl, ticketId, access, body);
    }), [config, config.baseUrl, config.token]);
    const fetchTicketDetails = (0, react_1.useCallback)((eventId, profileId, access) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchTicketDetails)(config.baseUrl, eventId, profileId, access);
    }), [config, config.baseUrl, config.token]);
    const fetchEventBookings = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventBookings)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const confirmBooking = (0, react_1.useCallback)((bookingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._confirmBooking)(config.baseUrl, config.token, bookingId);
    }), [config, config.baseUrl, config.token]);
    const createFreeTrialAccount = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createFreeTrialAccount)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const eventInvitationRegistration = (0, react_1.useCallback)((userId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._eventInvitationRegistration)(config.baseUrl, config.token, userId, data);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountDetails = (0, react_1.useCallback)((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAccountDetails)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const fetchSpeakers = (0, react_1.useCallback)((url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchSpeakers)(config.baseUrl, config.token, url);
    }), [config, config.baseUrl, config.token]);
    const fetchSpeakerById = (0, react_1.useCallback)((eventId, id) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchSpeakerById)(config.baseUrl, eventId, id);
    }), [config, config.baseUrl]);
    const fetchEditableEvents = (0, react_1.useCallback)((url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEditableEvents)(config.baseUrl, config.token, url);
    }), [config, config.baseUrl, config.token]);
    const fetchMySessions = (0, react_1.useCallback)((url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMySessions)(config.baseUrl, config.token, url);
    }), [config, config.baseUrl, config.token]);
    const updateAccountWithFiles = (0, react_1.useCallback)((accountId, updatedMyAccount, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateAccountWithFiles)(config.baseUrl, config.token, accountId, updatedMyAccount, files);
    }), [config, config.baseUrl, config.token]);
    const clearToken = (0, react_1.useCallback)(() => {
        setConfig({ token: null });
    }, []);
    const createPaymentAccount = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._createPaymentAccount)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const updatePaymentAccount = (0, react_1.useCallback)((paymentAccountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._updatePaymentAccount)(config.baseUrl, config.token, paymentAccountId, data);
    }), [config, config.baseUrl, config.token]);
    const inviteContentManager = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._inviteContentManager)(config.baseUrl, config.token, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const deleteContentManager = (0, react_1.useCallback)((accountId, profileId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._deleteContentManager)(config.baseUrl, config.token, accountId, profileId);
    }), [config, config.baseUrl, config.token]);
    const registerManager = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._registerManager)(config.baseUrl, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const registerManagerNative = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._registerManagerNative)(config.baseUrl, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const confirmManager = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._confirmManager)(config.baseUrl, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const confirmManagerNative = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._confirmManagerNative)(config.baseUrl, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const inviteFinanceManager = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._inviteFinanceManager)(config.baseUrl, config.token, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const deleteFinanceManager = (0, react_1.useCallback)((accountId, profileId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._deleteFinanceManager)(config.baseUrl, config.token, accountId, profileId);
    }), [config, config.baseUrl, config.token]);
    const deletePaymentAccount = (0, react_1.useCallback)((paymentAccountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._deletePaymentAccount)(config.baseUrl, config.token, paymentAccountId);
    }), [config, config.baseUrl, config.token]);
    const fetchAccountEvents = (0, react_1.useCallback)((url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchAccountEvents)(config.baseUrl, config.token, url);
    }), [config, config.baseUrl, config.token]);
    const fetchEventsByAccount = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchEventsByAccount)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const fetchEventPages = (0, react_1.useCallback)((eventId, nbPage, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventPages)(config.baseUrl, config.token, eventId, nbPage, params);
    }), [config, config.baseUrl, config.token]);
    const fetchPaymentAccount = (0, react_1.useCallback)((paymentAccountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchPaymentAccount)(config.baseUrl, config.token, paymentAccountId);
    }), [config, config.baseUrl, config.token]);
    const fetchPaymentAccounts = (0, react_1.useCallback)((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchPaymentAccounts)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const deletePage = (0, react_1.useCallback)((eventId, pageId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deletePage)(config.baseUrl, config.token, eventId, pageId);
    }), [config, config.baseUrl, config.token]);
    const updatePage = (0, react_1.useCallback)((pageId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updatePage)(config.baseUrl, config.token, pageId, data);
    }), [config, config.baseUrl, config.token]);
    const createPage = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createPage)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const deleteLocation = (0, react_1.useCallback)((pageId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteLocation)(config.baseUrl, config.token, pageId);
    }), [config, config.baseUrl, config.token]);
    const updateLocation = (0, react_1.useCallback)((locationId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateLocation)(config.baseUrl, config.token, locationId, data, files);
    }), [config, config.baseUrl, config.token]);
    const createLocation = (0, react_1.useCallback)((files, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createLocation)(config.baseUrl, config.token, files, data);
    }), [config, config.baseUrl, config.token]);
    const assignDocumentToEvent = (0, react_1.useCallback)((eventId, documentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._assignDocumentToEvent)(config.baseUrl, config.token, eventId, documentId);
    }), [config, config.baseUrl, config.token]);
    const deleteDocument = (0, react_1.useCallback)((documentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteDocument)(config.baseUrl, config.token, documentId);
    }), [config, config.baseUrl, config.token]);
    const updateDocument = (0, react_1.useCallback)((documentId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateDocument)(config.baseUrl, config.token, documentId, data);
    }), [config, config.baseUrl, config.token]);
    const createDocument = (0, react_1.useCallback)((files, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createDocument)(config.baseUrl, config.token, files, data);
    }), [config, config.baseUrl, config.token]);
    const createExhibitionDocument = (0, react_1.useCallback)((exhibitionId, files, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createExhibitionDocument)(config.baseUrl, config.token, exhibitionId, files, data);
    }), [config, config.baseUrl, config.token]);
    const createTrack = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, tracks_1._createTrack)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const updateTrack = (0, react_1.useCallback)((trackId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, tracks_1._updateTrack)(config.baseUrl, config.token, trackId, data);
    }), [config, config.baseUrl, config.token]);
    const deleteTrack = (0, react_1.useCallback)((trackId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, tracks_1._deleteTrack)(config.baseUrl, config.token, trackId);
    }), [config, config.baseUrl, config.token]);
    const fetchEventTemplates = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventTemplates)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const showAttendee = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._showAttendee)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const hideAttendee = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._hideAttendee)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const resendWelcomeEmail = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._resendWelcomeEmail)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const addOnsiteAttendee = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._addOnsiteAttendee)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const removeOnsiteAttendee = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._removeOnsiteAttendee)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const checkAvailabilityAttendee = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._checkAvailabilityAttendee)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const deleteDiscount = (0, react_1.useCallback)((discountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteDiscount)(config.baseUrl, config.token, discountId);
    }), [config, config.baseUrl, config.token]);
    const updateDiscount = (0, react_1.useCallback)((discountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateDiscount)(config.baseUrl, config.token, discountId, data);
    }), [config, config.baseUrl, config.token]);
    const createDiscount = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createDiscount)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const fetchEventDiscounts = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventDiscounts)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const deleteTicket = (0, react_1.useCallback)((ticketId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteTicket)(config.baseUrl, config.token, ticketId);
    }), [config, config.baseUrl, config.token]);
    const updateTicket = (0, react_1.useCallback)((ticketId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateTicket)(config.baseUrl, config.token, ticketId, data);
    }), [config, config.baseUrl, config.token]);
    const createTicket = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createTicket)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const deleteOption = (0, react_1.useCallback)((optionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteOption)(config.baseUrl, config.token, optionId);
    }), [config, config.baseUrl, config.token]);
    const updateOption = react_1.default.useCallback((optionId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateOption)(config.baseUrl, config.token, optionId, data);
    }), [config, config.baseUrl, config.token]);
    const createOption = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createOption)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const deleteGroup = (0, react_1.useCallback)((groupId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteGroup)(config.baseUrl, config.token, groupId);
    }), [config, config.baseUrl, config.token]);
    const updateSpeakerRole = react_1.default.useCallback((attendeeId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateSpeakerRole)(config.baseUrl, config.token, attendeeId, data);
    }), [config, config.baseUrl, config.token]);
    const deleteSpeakerRole = react_1.default.useCallback((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteSpeakerRole)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const updateGroup = react_1.default.useCallback((groupId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateGroup)(config.baseUrl, config.token, groupId, data);
    }), [config, config.baseUrl, config.token]);
    const createGroup = (0, react_1.useCallback)((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createGroup)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const importAgenda = (0, react_1.useCallback)((eventId, eventSource) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._importAgenda)(config.baseUrl, config.token, eventId, eventSource);
    }), [config, config.baseUrl, config.token]);
    const fetchAttendeesAvailabilities = (0, react_1.useCallback)((eventId, date) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAttendeesAvailabilities)(config.baseUrl, config.token, eventId, date);
    }), [config, config.baseUrl, config.token]);
    const updateEventTemplates = (0, react_1.useCallback)((templateId, eventId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEventTemplates)(config.baseUrl, config.token, templateId, eventId, data);
    }), [config, config.baseUrl, config.token]);
    const fetchEventNotifications = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventNotifications)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const sendSingleNotification = (0, react_1.useCallback)((attendeeId, message, date, url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._sendSingleNotification)(config.baseUrl, config.token, attendeeId, message, date, url);
    }), [config, config.baseUrl, config.token]);
    const sendNotification = (0, react_1.useCallback)((eventId, message, date, url) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._sendNotification)(config.baseUrl, config.token, eventId, message, date, url);
    }), [config, config.baseUrl, config.token]);
    const updateEvent = (0, react_1.useCallback)((eventId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateEvent)(config.baseUrl, config.token, eventId, data, files);
    }), [config, config.baseUrl, config.token]);
    const resendConfirmationEmail = (0, react_1.useCallback)((eventId, attendeeList) => {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._resendConfirmationEmail)(config.baseUrl, config.token, eventId, attendeeList);
    }, [config, config.baseUrl, config.token]);
    const createEvent = (0, react_1.useCallback)((data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createEvent)(config.baseUrl, config.token, data, files);
    }), [config, config.baseUrl, config.token]);
    const fetchEventTickets = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventTickets)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchEventOptions = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventOptions)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const assignPaymentAccount = (0, react_1.useCallback)((eventId, requestData) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._assignPaymentAccount)(config.baseUrl, config.token, eventId, requestData);
    }), [config, config.baseUrl, config.token]);
    const unassignPaymentAccount = (0, react_1.useCallback)((eventId, paymentAccountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._unassignPaymentAccount)(config.baseUrl, config.token, eventId, paymentAccountId);
    }), [config, config.baseUrl, config.token]);
    const fetchAttendeeProfile = react_1.default.useCallback((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchAttendeeProfile)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const fetchAttendees = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchAttendees)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchColocatedAttendees = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchColocatedAttendees)(config.baseUrl, eventId);
    }), [config, config.baseUrl]);
    const fetchMyUser = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchMyUser)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const updateAttendeeImage = react_1.default.useCallback((file, param, attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateAttendeeImage)(config.baseUrl, config.token, file, param, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const updateAttendeeImageNative = react_1.default.useCallback((file, param, attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateAttendeeImageNative)(config.baseUrl, config.token, file, param, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const updateAttendee = react_1.default.useCallback((updatedAttendee, attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateAttendee)(config.baseUrl, config.token, updatedAttendee, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const updateGlobalAttendeeImage = react_1.default.useCallback((file, param) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateGlobalAttendeeImage)(config.baseUrl, config.token, file, param);
    }), [config, config.baseUrl, config.token]);
    const updateGlobalAttendeeImageNative = react_1.default.useCallback((file, param) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateGlobalAttendeeImageNative)(config.baseUrl, config.token, file, param);
    }), [config, config.baseUrl, config.token]);
    const updateGlobalAttendee = react_1.default.useCallback((updatedAttendee) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateGlobalAttendee)(config.baseUrl, config.token, updatedAttendee);
    }), [config, config.baseUrl, config.token]);
    const fetchMyConnections = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchMyConnections)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const addConnection = react_1.default.useCallback((profile, leadsToken) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._addConnection)(config.baseUrl, config.token, profile, leadsToken);
    }), [config, config.baseUrl, config.token]);
    const removeConnection = react_1.default.useCallback((profile) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._removeConnection)(config.baseUrl, config.token, profile);
    }), [config, config.baseUrl, config.token]);
    const pinAttendee = react_1.default.useCallback((attendeeId, pinAttendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._pinAttendee)(config.baseUrl, config.token, attendeeId, pinAttendeeId);
    }), [config, config.baseUrl, config.token]);
    const unpinAttendee = react_1.default.useCallback((attendeeId, pinAttendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._unpinAttendee)(config.baseUrl, config.token, attendeeId, pinAttendeeId);
    }), [config, config.baseUrl, config.token]);
    const confirmMyEventInvitation = react_1.default.useCallback((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._confirmMyEventInvitation)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const checkIn = react_1.default.useCallback((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._checkIn)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const checkout = react_1.default.useCallback((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._checkout)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const sendAttendeeOnboardingAnswers = react_1.default.useCallback((attendeeId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._sendAttendeeOnboardingAnswers)(config.baseUrl, config.token, attendeeId, body);
    }), [config, config.baseUrl, config.token]);
    const createAttendee = react_1.default.useCallback((eventId, type, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._createAttendee)(config.baseUrl, config.token, eventId, type, body);
    }), [config, config.baseUrl, config.token]);
    const importProfileFromLinkedIn = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._importProfileFromLinkedIn)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const reportAttendeeAction = react_1.default.useCallback((requestData) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._reportAttendeeAction)(config.baseUrl, config.token, requestData);
    }), [config, config.baseUrl, config.token]);
    const fetchMyNotes = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchMyNotes)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const createNote = react_1.default.useCallback((note) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._createNote)(config.baseUrl, config.token, note);
    }), [config, config.baseUrl, config.token]);
    const updateNote = react_1.default.useCallback((noteId, note) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._updateNote)(config.baseUrl, config.token, noteId, note);
    }), [config, config.baseUrl, config.token]);
    const deleteNote = react_1.default.useCallback((noteId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._deleteNote)(config.baseUrl, config.token, noteId);
    }), [config, config.baseUrl, config.token]);
    const fetchUserNotifications = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchUserNotifications)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const markUserNotificationAsRead = react_1.default.useCallback((notificationId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._markUserNotificationAsRead)(config.baseUrl, config.token, notificationId);
    }), [config, config.baseUrl, config.token]);
    const deleteUserNotification = react_1.default.useCallback((notificationId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._deleteUserNotification)(config.baseUrl, config.token, notificationId);
    }), [config, config.baseUrl, config.token]);
    const deleteAllUserNotifications = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._deleteAllUserNotifications)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const fetchAgenda = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._fetchAgenda)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchZoomSignature = react_1.default.useCallback((account, meetingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._fetchZoomSignature)(config.baseUrl, config.token, account, meetingId);
    }), [config, config.baseUrl, config.token]);
    const pinSession = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._pinSession)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const unpinSession = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._unpinSession)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const rateSession = react_1.default.useCallback((sessionId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._rateSession)(config.baseUrl, config.token, sessionId, body);
    }), [config, config.baseUrl, config.token]);
    const reserveSeat = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._reserveSeat)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const removeSeat = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._removeSeat)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const removeSeatNative = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._removeSeatNative)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const watchSession = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._watchSession)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const postSessionComment = react_1.default.useCallback((sessionId, message) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._postSessionComment)(config.baseUrl, config.token, sessionId, message);
    }), [config, config.baseUrl, config.token]);
    const refetchSessionDiscussion = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._refetchSessionDiscussion)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const reportSessionAction = react_1.default.useCallback((sessionId, requestData) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._reportSessionAction)(config.baseUrl, config.token, sessionId, requestData);
    }), [config, config.baseUrl, config.token]);
    const fetchMeetings = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._fetchMeetings)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const fetchArrangedMeetings = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._fetchArrangedMeetings)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchLocation = react_1.default.useCallback((locationId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._fetchLocation)(config.baseUrl, config.token, locationId);
    }), [config, config.baseUrl, config.token]);
    const cancelMeeting = react_1.default.useCallback((meetingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._cancelMeeting)(config.baseUrl, config.token, meetingId);
    }), [config, config.baseUrl, config.token]);
    const declineMeeting = react_1.default.useCallback((meetingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._declineMeeting)(config.baseUrl, config.token, meetingId);
    }), [config, config.baseUrl, config.token]);
    const confirmMeeting = react_1.default.useCallback((meetingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._confirmMeeting)(config.baseUrl, config.token, meetingId);
    }), [config, config.baseUrl, config.token]);
    const rateMeeting = react_1.default.useCallback((meetingId, rate) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._rateMeeting)(config.baseUrl, config.token, meetingId, rate);
    }), [config, config.baseUrl, config.token]);
    const deliverMeeting = react_1.default.useCallback((meetingId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._deliverMeeting)(config.baseUrl, config.token, meetingId);
    }), [config, config.baseUrl, config.token]);
    const createMeeting = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._createMeeting)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const createArrangedMeeting = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._createArrangedMeeting)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const fetchPosts = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._fetchPosts)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchPostDetails = react_1.default.useCallback((postId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._fetchPostDetails)(config.baseUrl, config.token, postId);
    }), [config, config.baseUrl, config.token]);
    const likePost = react_1.default.useCallback((postId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._likePost)(config.baseUrl, config.token, postId);
    }), [config, config.baseUrl, config.token]);
    const unlikePost = react_1.default.useCallback((postId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._unlikePost)(config.baseUrl, config.token, postId);
    }), [config, config.baseUrl, config.token]);
    const likeComment = react_1.default.useCallback((postId, commentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._likeComment)(config.baseUrl, config.token, postId, commentId);
    }), [config, config.baseUrl, config.token]);
    const unlikeComment = react_1.default.useCallback((postId, commentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._unlikeComment)(config.baseUrl, config.token, postId, commentId);
    }), [config, config.baseUrl, config.token]);
    const unlikeCommentNative = react_1.default.useCallback((postId, commentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._unlikeCommentNative)(config.baseUrl, config.token, postId, commentId);
    }), [config, config.baseUrl, config.token]);
    const unlikePostNative = react_1.default.useCallback((postId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._unlikePostNative)(config.baseUrl, config.token, postId);
    }), [config, config.baseUrl, config.token]);
    const addComment = react_1.default.useCallback((postId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._addComment)(config.baseUrl, config.token, postId, body);
    }), [config, config.baseUrl, config.token]);
    const addPost = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._addPost)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const updatePost = react_1.default.useCallback((postId, body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._updatePost)(config.baseUrl, config.token, postId, body);
    }), [config, config.baseUrl, config.token]);
    const deletePost = react_1.default.useCallback((postId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._deletePost)(config.baseUrl, config.token, postId);
    }), [config, config.baseUrl, config.token]);
    const addPostNative = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._addPostNative)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const deleteComment = react_1.default.useCallback((postId, commentId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, posts_1._deleteComment)(config.baseUrl, config.token, postId, commentId);
    }), [config, config.baseUrl, config.token]);
    const fetchPages = react_1.default.useCallback((eventId, nbPage, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, pages_1._fetchPages)(config.baseUrl, config.token, eventId, nbPage, params);
    }), [config, config.baseUrl, config.token]);
    const fetchEventTracks = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, tracks_1._fetchEventTracks)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchCalendarEvents = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, calendar_1._fetchCalendarEvents)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const blockEvent = react_1.default.useCallback((event, startDate, endDate) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, calendar_1._blockEvent)(config.baseUrl, config.token, event, startDate, endDate);
    }), [config, config.baseUrl, config.token]);
    const unblockEvent = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, calendar_1._unblockEvent)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchAccounts = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAccounts)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const fetchEventsForAccount = react_1.default.useCallback((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchEventsForAccount)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const fetchAllPublicEvents = react_1.default.useCallback((nbPage, params) => __awaiter(this, void 0, void 0, function* () {
        return (0, public_1._fetchAllPublicEvents)(config.baseUrl, nbPage, params);
    }), [config, config.baseUrl, config.token]);
    const fetchPublicExhibitions = react_1.default.useCallback((eventId, nbPage, params) => __awaiter(this, void 0, void 0, function* () {
        return (0, public_1._fetchPublicExhibitions)(config.baseUrl, eventId, nbPage, params);
    }), [config, config.baseUrl, config.token]);
    const fetchPublicAgenda = react_1.default.useCallback((eventId, nbPage, params) => __awaiter(this, void 0, void 0, function* () {
        return (0, public_1._fetchPublicAgenda)(config.baseUrl, eventId, nbPage, params);
    }), [config, config.baseUrl, config.token]);
    const logout = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._logout)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const fetchZoomContent = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchZoomContent)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const fetchYoutubeContent = react_1.default.useCallback((reference) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchYoutubeContent)(config.baseUrl, config.token, reference);
    }), [config, config.baseUrl, config.token]);
    const createStream = react_1.default.useCallback((data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createStream)(config.baseUrl, config.token, data);
    }), [config, config.baseUrl, config.token]);
    const updateStream = (0, react_1.useCallback)((streamId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateStream)(config.baseUrl, config.token, streamId, data);
    }), [config, config.baseUrl, config.token]);
    const deleteStream = react_1.default.useCallback((streamId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteStream)(config.baseUrl, config.token, streamId);
    }), [config, config.baseUrl, config.token]);
    const fetchAllExhibitions = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchAllExhibitions)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchMyExhibitions = react_1.default.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMyExhibitions)(config.baseUrl, config.token);
    }), [config, config.baseUrl, config.token]);
    const createExhibition = react_1.default.useCallback((files, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createExhibition)(config.baseUrl, config.token, files, data);
    }), [config, config.baseUrl, config.token]);
    const importExhibition = react_1.default.useCallback((eventId, eventSource) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._importExhibition)(config.baseUrl, config.token, eventId, eventSource);
    }), [config, config.baseUrl, config.token]);
    const importEventWebsiteContent = (0, react_1.useCallback)((eventId, eventSource, keysList) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return yield (0, event_1._importEventWebsiteContent)(config.baseUrl, config.token, eventId, eventSource, keysList);
    }), [config, config.baseUrl, config.token]);
    const updateExhibition = react_1.default.useCallback((exhibitionId, files, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updateExhibition)(config.baseUrl, config.token, exhibitionId, files, data);
    }), [config, config.baseUrl, config.token]);
    const deleteExhibition = react_1.default.useCallback((exhibitionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deleteExhibition)(config.baseUrl, config.token, exhibitionId);
    }), [config, config.baseUrl, config.token]);
    const fetchSelectedEventSessions = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._fetchSelectedEventSessions)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const createSession = react_1.default.useCallback((data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._createSession)(config.baseUrl, config.token, data, files);
    }), [config, config.baseUrl, config.token]);
    const updateSession = react_1.default.useCallback((sessionId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._updateSession)(config.baseUrl, config.token, sessionId, data, files);
    }), [config, config.baseUrl, config.token]);
    const deleteSession = react_1.default.useCallback((sessionId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._deleteSession)(config.baseUrl, config.token, sessionId);
    }), [config, config.baseUrl, config.token]);
    const promoteSession = react_1.default.useCallback((sessionId, promotionDate) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, sessions_1._promoteSession)(config.baseUrl, config.token, sessionId, promotionDate);
    }), [config, config.baseUrl, config.token]);
    const editMeeting = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._editMeeting)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    const fetchEventMeetingsStatistics = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._fetchEventMeetingsStatistics)(config.baseUrl, config.token, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchPortfolios = react_1.default.useCallback((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchPortfolios)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const deletePortfolio = react_1.default.useCallback((portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deletePortfolio)(config.baseUrl, config.token, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const assignPortfolio = react_1.default.useCallback((eventId, portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._assignPortfolio)(config.baseUrl, config.token, eventId, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const unassignPortfolio = react_1.default.useCallback((eventId, portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._unassignPortfolio)(config.baseUrl, config.token, eventId, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const createPortfolio = react_1.default.useCallback((data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createPortfolio)(config.baseUrl, config.token, data, files);
    }), [config, config.baseUrl, config.token]);
    const updatePortfolio = react_1.default.useCallback((portfolioId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updatePortfolio)(config.baseUrl, config.token, portfolioId, data, files);
    }), [config, config.baseUrl, config.token]);
    const fetchPortfolioDetails = react_1.default.useCallback((portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchPortfolioDetails)(config.baseUrl, config.token, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const fetchPortfolioEvents = react_1.default.useCallback((portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchPortfolioEvents)(config.baseUrl, config.token, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const fetchBlogPages = react_1.default.useCallback((accountId, portfolioId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchBlogPages)(config.baseUrl, config.token, accountId, portfolioId);
    }), [config, config.baseUrl, config.token]);
    const createBlogPage = react_1.default.useCallback((portfolioId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._createBlogPage)(config.baseUrl, config.token, portfolioId, data, files);
    }), [config, config.baseUrl, config.token]);
    const updatePortfolioBlogPage = react_1.default.useCallback((portfolioId, blogPostId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._updatePortfolioBlogPage)(config.baseUrl, config.token, portfolioId, blogPostId, data, files);
    }), [config, config.baseUrl, config.token]);
    const deletePortfolioBlogPage = react_1.default.useCallback((portfolioId, blogPostId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deletePortfolioBlogPage)(config.baseUrl, config.token, portfolioId, blogPostId);
    }), [config, config.baseUrl, config.token]);
    const fetchColocatedEvents = (0, react_1.useCallback)((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchColocatedEvents)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const fetchColocatedEventDetails = (0, react_1.useCallback)((accountId, eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchColocatedEventDetails)(config.baseUrl, config.token, accountId, eventId);
    }), [config, config.baseUrl, config.token]);
    const fetchFeeds = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchFeeds)(config.baseUrl, config.token, accountId, params);
    }), [config, config.baseUrl, config.token]);
    const fetchPublicFeeds = (0, react_1.useCallback)((accountId, params) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateBaseUrl)(config);
        return (0, public_1._fetchPublicFeeds)(config.baseUrl, accountId, params);
    }), [config, config.baseUrl]);
    const fetchPublicOffer = (0, react_1.useCallback)((offerId, userId, access) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateBaseUrl)(config);
        return (0, public_1._fetchPublicOffer)(config.baseUrl, offerId, userId, access);
    }), [config, config.baseUrl]);
    const uploadPublicOfferPdf = (0, react_1.useCallback)((offerId, userId, access, file) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateBaseUrl)(config);
        return (0, public_1._uploadPublicOfferPdf)(config.baseUrl, offerId, userId, access, file);
    }), [config, config.baseUrl]);
    const fetchFeed = (0, react_1.useCallback)((accountId, feedId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchFeed)(config.baseUrl, config.token, accountId, feedId);
    }), [config, config.baseUrl, config.token]);
    const createFeed = (0, react_1.useCallback)((accountId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._createFeed)(config.baseUrl, config.token, accountId, data, files);
    }), [config, config.baseUrl, config.token]);
    const updateFeed = (0, react_1.useCallback)((accountId, feedId, data, files) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._updateFeed)(config.baseUrl, config.token, accountId, feedId, data, files);
    }), [config, config.baseUrl, config.token]);
    const deleteFeed = (0, react_1.useCallback)((accountId, feedId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._deleteFeed)(config.baseUrl, config.token, accountId, feedId);
    }), [config, config.baseUrl, config.token]);
    const createColocatedEvents = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._createColocatedEvents)(config.baseUrl, config.token, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const editColocatedEvents = (0, react_1.useCallback)((id, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._editColocatedEvents)(config.baseUrl, config.token, id, data);
    }), [config, config.baseUrl, config.token]);
    const deleteColocatedEvents = (0, react_1.useCallback)((id) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._deleteColocatedEvents)(config.baseUrl, config.token, id);
    }), [config, config.baseUrl, config.token]);
    const fetchMediaDirectories = react_1.default.useCallback((accountId, path) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMediaDirectories)(config.baseUrl, config.token, accountId, path);
    }), [config, config.baseUrl, config.token]);
    const fetchMediaDirectoryFiles = react_1.default.useCallback((accountId, filepath) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMediaDirectoryFiles)(config.baseUrl, config.token, accountId, filepath);
    }), [config, config.baseUrl, config.token]);
    const fetchMediaFileDetails = react_1.default.useCallback((accountId, path) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._fetchMediaFileDetails)(config.baseUrl, config.token, accountId, path);
    }), [config, config.baseUrl, config.token]);
    const uploadFileToFolder = (0, react_1.useCallback)((accountId, folderPath, fileName, blob) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._uploadFileToFolder)(config.baseUrl, config.token, accountId, folderPath, fileName, blob);
    }), [config, config.baseUrl, config.token]);
    const renameFolder = (0, react_1.useCallback)((accountId, path, name_old, name_new) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._renameFolder)(config.baseUrl, config.token, accountId, path, name_old, name_new);
    }), [config, config.baseUrl, config.token]);
    const fetchAttendeeDetails = (0, react_1.useCallback)((attendeeId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, attendee_1._fetchAttendeeDetails)(config.baseUrl, config.token, attendeeId);
    }), [config, config.baseUrl, config.token]);
    const updatePackages = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._updatePackages)(config.baseUrl, config.token, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const fetchSessionTypes = (0, react_1.useCallback)((accountId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._fetchSessionTypes)(config.baseUrl, config.token, accountId);
    }), [config, config.baseUrl, config.token]);
    const updateSessionTypes = (0, react_1.useCallback)((accountId, data) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, authentication_1._updateSessionTypes)(config.baseUrl, config.token, accountId, data);
    }), [config, config.baseUrl, config.token]);
    const importTickets = (0, react_1.useCallback)((eventId, ticketsList) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._importTickets)(config.baseUrl, config.token, eventId, ticketsList);
    }), [config, config.baseUrl, config.token]);
    const fetchColocatedAgenda = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateBaseUrl)(config);
        return (0, sessions_1._fetchColocatedAgenda)(config.baseUrl, eventId);
    }), [config, config.baseUrl]);
    const fetchPublicEventAdvertisement = (0, react_1.useCallback)((eventId) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateBaseUrl)(config);
        return (0, event_1._fetchPublicEventAdvertisement)(config.baseUrl, eventId);
    }), [config, config.baseUrl]);
    const activateDataManagers = (0, react_1.useCallback)((eventId, attendeeIds) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._activateDataManagers)(config.baseUrl, config.token, eventId, attendeeIds);
    }), [config, config.baseUrl, config.token]);
    const deactivateDataManagers = (0, react_1.useCallback)((eventId, attendeeIds) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, event_1._deactivateDataManagers)(config.baseUrl, config.token, eventId, attendeeIds);
    }), [config, config.baseUrl, config.token]);
    const fetchPublicEventStatistics = react_1.default.useCallback((eventId) => __awaiter(this, void 0, void 0, function* () {
        return (0, public_1._fetchPublicEventStatistics)(config.baseUrl, eventId);
    }), [config, config.baseUrl]);
    const editMeetingNative = react_1.default.useCallback((body) => __awaiter(this, void 0, void 0, function* () {
        (0, api_1.validateConfig)(config);
        return (0, meetings_1._editMeetingNative)(config.baseUrl, config.token, body);
    }), [config, config.baseUrl, config.token]);
    return (react_1.default.createElement(EventAPIContext_1.default.Provider, { value: {
            config,
            init,
            initWithToken,
            initWithoutToken,
            fetchEventRegistrations,
            fetchEventDetails,
            fetchExhibitions,
            fetchExhibitionDetails,
            fetchEventLocations,
            fetchEventStreams,
            fetchUserRegistrationsEvents,
            fetchEventDocuments,
            reportExhibitionAction,
            pinDocument,
            unpinDocument,
            pinExhibition,
            unpinExhibition,
            fetchEventGroups,
            fetchPublicEventGroups,
            deleteMediaDirectories,
            addMediaFolder,
            updateEventWebsite,
            deleteMediaDirectoryFiles,
            updateAccountGroup,
            updateVisibilityAttendee,
            fetchAccountGroups,
            fetchEventAttendeeActions,
            fetchAccountBookings,
            fetchAccountDocuments,
            fetchAccountProfiles,
            resendBookingEmail,
            resendTicketEmail,
            postTicketDetails,
            confirmAttendee,
            checkBooking,
            createBooking,
            fetchEventOrderedTickets,
            acceptInternTicket,
            fetchTickets,
            getPublicRegistrationForm,
            fetchMyBookings,
            assignTicket,
            acceptTicket,
            fetchTicketDetails,
            fetchEventBookings,
            confirmBooking,
            createFreeTrialAccount,
            eventInvitationRegistration,
            fetchAccountDetails,
            fetchSpeakers,
            fetchSpeakerById,
            fetchEditableEvents,
            fetchMySessions,
            updateAccountWithFiles,
            clearToken,
            createPaymentAccount,
            updatePaymentAccount,
            inviteContentManager,
            deleteContentManager,
            registerManager,
            registerManagerNative,
            confirmManager,
            confirmManagerNative,
            inviteFinanceManager,
            deleteFinanceManager,
            deletePaymentAccount,
            fetchAccountEvents,
            fetchPaymentAccount,
            fetchPaymentAccounts,
            fetchEventPages,
            deletePage,
            updatePage,
            createPage,
            deleteLocation,
            updateLocation,
            createLocation,
            deleteDocument,
            createDocument,
            createExhibitionDocument,
            assignDocumentToEvent,
            updateDocument,
            createTrack,
            updateTrack,
            deleteTrack,
            fetchEventTemplates,
            showAttendee,
            hideAttendee,
            resendWelcomeEmail,
            addOnsiteAttendee,
            removeOnsiteAttendee,
            checkAvailabilityAttendee,
            deleteDiscount,
            updateDiscount,
            createDiscount,
            fetchEventDiscounts,
            deleteTicket,
            updateTicket,
            createTicket,
            deleteOption,
            updateOption,
            createOption,
            deleteGroup,
            updateGroup,
            updateSpeakerRole,
            deleteSpeakerRole,
            createGroup,
            importAgenda,
            fetchAttendeesAvailabilities,
            updateEventTemplates,
            fetchEventNotifications,
            sendSingleNotification,
            sendNotification,
            updateEvent,
            resendConfirmationEmail,
            createEvent,
            fetchEventTickets,
            fetchEventOptions,
            assignPaymentAccount,
            unassignPaymentAccount,
            fetchAttendeeProfile,
            fetchAttendees,
            fetchColocatedAttendees,
            fetchMyUser,
            updateAttendeeImage,
            updateAttendee,
            updateGlobalAttendeeImage,
            updateGlobalAttendee,
            fetchMyConnections,
            addConnection,
            removeConnection,
            pinAttendee,
            unpinAttendee,
            confirmMyEventInvitation,
            checkIn,
            checkout,
            sendAttendeeOnboardingAnswers,
            createAttendee,
            importProfileFromLinkedIn,
            reportAttendeeAction,
            fetchMyNotes,
            createNote,
            updateNote,
            deleteNote,
            fetchUserNotifications,
            markUserNotificationAsRead,
            deleteUserNotification,
            deleteAllUserNotifications,
            fetchAgenda,
            fetchZoomSignature,
            pinSession,
            unpinSession,
            rateSession,
            reserveSeat,
            removeSeat,
            removeSeatNative,
            watchSession,
            postSessionComment,
            refetchSessionDiscussion,
            reportSessionAction,
            fetchMeetings,
            fetchArrangedMeetings,
            fetchLocation,
            cancelMeeting,
            declineMeeting,
            confirmMeeting,
            rateMeeting,
            deliverMeeting,
            createMeeting,
            createArrangedMeeting,
            fetchPosts,
            fetchPostDetails,
            likePost,
            unlikePost,
            likeComment,
            unlikeComment,
            unlikeCommentNative,
            unlikePostNative,
            addComment,
            addPost,
            updatePost,
            deletePost,
            deleteComment,
            fetchPages,
            fetchEventTracks,
            fetchCalendarEvents,
            blockEvent,
            unblockEvent,
            fetchAccounts,
            fetchEventsForAccount,
            fetchAllPublicEvents,
            fetchPublicExhibitions,
            fetchPublicAgenda,
            fetchPublicEventStatistics,
            logout,
            fetchZoomContent,
            fetchYoutubeContent,
            createStream,
            updateStream,
            deleteStream,
            fetchAllExhibitions,
            fetchMyExhibitions,
            createExhibition,
            importExhibition,
            updateExhibition,
            deleteExhibition,
            fetchSelectedEventSessions,
            createSession,
            updateSession,
            deleteSession,
            promoteSession,
            editMeeting,
            fetchEventMeetingsStatistics,
            fetchPortfolios,
            deletePortfolio,
            assignPortfolio,
            unassignPortfolio,
            createPortfolio,
            updatePortfolio,
            fetchPortfolioDetails,
            fetchPortfolioEvents,
            fetchBlogPages,
            createBlogPage,
            createAccountGroup,
            getPublicGroupDetails,
            updatePortfolioBlogPage,
            deletePortfolioBlogPage,
            fetchColocatedEvents,
            fetchFeeds,
            fetchPublicFeeds,
            fetchPublicOffer,
            uploadPublicOfferPdf,
            fetchFeed,
            createFeed,
            updateFeed,
            deleteFeed,
            fetchColocatedEventDetails,
            createColocatedEvents,
            editColocatedEvents,
            deleteColocatedEvents,
            fetchMediaDirectories,
            fetchMediaDirectoryFiles,
            fetchMediaFileDetails,
            uploadFileToFolder,
            renameFolder,
            fetchAttendeeDetails,
            updatePackages,
            updateAttendeeImageNative,
            updateGlobalAttendeeImageNative,
            fetchEventsByAccount,
            importTickets,
            importEventWebsiteContent,
            fetchPublicEventAdvertisement,
            fetchColocatedAgenda,
            activateDataManagers,
            deactivateDataManagers,
            updateSessionTypes,
            fetchSessionTypes,
            createOffer,
            fetchOffers,
            fetchOfferDetails,
            updateOffer,
            sendOffer,
            approveOffer,
            createTestimonial,
            updateTestimonial,
            createStatistic,
            updateStatistic,
            createKeyTopic,
            updateKeyTopic,
            updateEventTargetGroups,
            updateEventCitations,
            updateEventSurveys,
            updateEventTickets,
            updateEventFaqs,
            updateEventSpeakerAdverts,
            addPostNative,
            editMeetingNative,
        } }, props.children));
}
exports.BaseAPI = {
    fetchEventRegistrations: event_1._fetchEventRegistrations,
    fetchExhibitions: event_1._fetchExhibitions,
    fetchEventDetails: event_1._fetchEventDetails,
    fetchExhibitionDetails: event_1._fetchExhibitionDetails,
    fetchEventLocations: event_1._fetchEventLocations,
    fetchEventStreams: event_1._fetchEventStreams,
    fetchUserRegistrationsEvents: event_1._fetchUserRegistrationsEvents,
    fetchEventDocuments: event_1._fetchEventDocuments,
    reportExhibitionAction: event_1._reportExhibitionAction,
    pinDocument: event_1._pinDocument,
    unpinDocument: event_1._unpinDocument,
    pinExhibition: event_1._pinExhibition,
    unpinExhibition: event_1._unpinExhibition,
    fetchEventGroups: event_1._fetchEventGroups,
    fetchPublicEventGroups: event_1._fetchPublicEventGroups,
    deleteMediaDirectories: event_1._deleteMediaDirectories,
    addMediaFolder: event_1._addMediaFolder,
    updateEventWebsite: event_1._updateEventWebsite,
    deleteMediaDirectoryFiles: event_1._deleteMediaDirectoryFiles,
    updateAccountGroup: authentication_1._updateAccountGroup,
    updateVisibilityAttendee: attendee_1._updateVisibilityAttendee,
    fetchAccountGroups: authentication_1._fetchAccountGroups,
    fetchEventAttendeeActions: event_1._fetchEventAttendeeActions,
    fetchAccountBookings: event_1._fetchAccountBookings,
    fetchAccountDocuments: event_1._fetchAccountDocuments,
    fetchAccountProfiles: event_1._fetchAccountProfiles,
    resendTicketEmail: event_1._resendTicketEmail,
    resendBookingEmail: event_1._resendBookingEmail,
    postTicketDetails: event_1._postTicketDetails,
    confirmAttendee: attendee_1._confirmAttendee,
    checkBooking: event_1._checkBooking,
    createBooking: event_1._createBooking,
    fetchEventOrderedTickets: event_1._fetchEventOrderedTickets,
    acceptInternTicket: event_1._acceptInternTicket,
    fetchTickets: event_1._fetchTickets,
    getPublicRegistrationForm: public_1._getPublicRegistrationForm,
    fetchMyBookings: event_1._fetchMyBookings,
    assignTicket: event_1._assignTicket,
    acceptTicket: event_1._acceptTicket,
    fetchTicketDetails: event_1._fetchTicketDetails,
    fetchEventBookings: event_1._fetchEventBookings,
    confirmBooking: event_1._confirmBooking,
    createFreeTrialAccount: event_1._createFreeTrialAccount,
    eventInvitationRegistration: event_1._eventInvitationRegistration,
    fetchAccountDetails: event_1._fetchAccountDetails,
    fetchSpeakers: event_1._fetchSpeakers,
    fetchSpeakerById: event_1._fetchSpeakerById,
    fetchEditableEvents: event_1._fetchEditableEvents,
    fetchMySessions: event_1._fetchMySessions,
    updateAccountWithFiles: event_1._updateAccountWithFiles,
    createPaymentAccount: authentication_1._createPaymentAccount,
    updatePaymentAccount: authentication_1._updatePaymentAccount,
    inviteContentManager: authentication_1._inviteContentManager,
    deleteContentManager: authentication_1._deleteContentManager,
    registerManager: authentication_1._registerManager,
    registerManagerNative: authentication_1._registerManagerNative,
    confirmManager: authentication_1._confirmManager,
    confirmManagerNative: authentication_1._confirmManagerNative,
    inviteFinanceManager: authentication_1._inviteFinanceManager,
    deleteFinanceManager: authentication_1._deleteFinanceManager,
    deletePaymentAccount: authentication_1._deletePaymentAccount,
    fetchAccountEvents: authentication_1._fetchAccountEvents,
    fetchPaymentAccount: authentication_1._fetchPaymentAccount,
    fetchPaymentAccounts: authentication_1._fetchPaymentAccounts,
    fetchEventPages: event_1._fetchEventPages,
    deletePage: event_1._deletePage,
    updatePage: event_1._updatePage,
    createPage: event_1._createPage,
    createLocation: event_1._createLocation,
    updateLocation: event_1._updateLocation,
    deleteLocation: event_1._deleteLocation,
    deleteDocument: event_1._deleteDocument,
    createDocument: event_1._createDocument,
    createExhibitionDocument: event_1._createExhibitionDocument,
    assignDocumentToEvent: event_1._assignDocumentToEvent,
    updateDocument: event_1._updateDocument,
    createTrack: tracks_1._createTrack,
    updateTrack: tracks_1._updateTrack,
    deleteTrack: tracks_1._deleteTrack,
    fetchEventTemplates: event_1._fetchEventTemplates,
    showAttendee: attendee_1._showAttendee,
    hideAttendee: attendee_1._hideAttendee,
    resendWelcomeEmail: attendee_1._resendWelcomeEmail,
    addOnsiteAttendee: attendee_1._addOnsiteAttendee,
    removeOnsiteAttendee: attendee_1._removeOnsiteAttendee,
    deleteDiscount: event_1._deleteDiscount,
    updateDiscount: event_1._updateDiscount,
    createDiscount: event_1._createDiscount,
    fetchEventDiscounts: event_1._fetchEventDiscounts,
    checkAvailabilityAttendee: attendee_1._checkAvailabilityAttendee,
    deleteTicket: event_1._deleteTicket,
    updateTicket: event_1._updateTicket,
    createTicket: event_1._createTicket,
    deleteOption: event_1._deleteOption,
    updateOption: event_1._updateOption,
    createOption: event_1._createOption,
    deleteGroup: event_1._deleteGroup,
    updateGroup: event_1._updateGroup,
    updateSpeakerRole: event_1._updateSpeakerRole,
    deleteSpeakerRole: event_1._deleteSpeakerRole,
    createGroup: event_1._createGroup,
    importAgenda: event_1._importAgenda,
    fetchAttendeesAvailabilities: event_1._fetchAttendeesAvailabilities,
    updateEventTemplates: event_1._updateEventTemplates,
    sendNotification: event_1._sendNotification,
    sendSingleNotification: event_1._sendSingleNotification,
    updateEvent: event_1._updateEvent,
    fetchEventNotifications: event_1._fetchEventNotifications,
    resendConfirmationEmail: attendee_1._resendConfirmationEmail,
    createEvent: event_1._createEvent,
    fetchEventTickets: event_1._fetchEventTickets,
    fetchEventOptions: event_1._fetchEventOptions,
    assignPaymentAccount: event_1._assignPaymentAccount,
    unassignPaymentAccount: event_1._unassignPaymentAccount,
    fetchAttendeeProfile: attendee_1._fetchAttendeeProfile,
    fetchAttendees: attendee_1._fetchAttendees,
    fetchColocatedAttendees: attendee_1._fetchColocatedAttendees,
    fetchMyUser: attendee_1._fetchMyUser,
    updateAttendeeImage: attendee_1._updateAttendeeImage,
    updateAttendee: attendee_1._updateAttendee,
    updateGlobalAttendeeImage: attendee_1._updateGlobalAttendeeImage,
    updateGlobalAttendee: attendee_1._updateGlobalAttendee,
    fetchMyConnections: attendee_1._fetchMyConnections,
    addConnection: attendee_1._addConnection,
    removeConnection: attendee_1._removeConnection,
    pinAttendee: attendee_1._pinAttendee,
    unpinAttendee: attendee_1._unpinAttendee,
    confirmMyEventInvitation: attendee_1._confirmMyEventInvitation,
    checkIn: attendee_1._checkIn,
    checkout: attendee_1._checkout,
    sendAttendeeOnboardingAnswers: attendee_1._sendAttendeeOnboardingAnswers,
    createAttendee: attendee_1._createAttendee,
    importProfileFromLinkedIn: attendee_1._importProfileFromLinkedIn,
    reportAttendeeAction: attendee_1._reportAttendeeAction,
    fetchMyNotes: attendee_1._fetchMyNotes,
    createNote: attendee_1._createNote,
    updateNote: attendee_1._updateNote,
    deleteNote: attendee_1._deleteNote,
    fetchUserNotifications: attendee_1._fetchUserNotifications,
    markUserNotificationAsRead: attendee_1._markUserNotificationAsRead,
    deleteUserNotification: attendee_1._deleteUserNotification,
    deleteAllUserNotifications: attendee_1._deleteAllUserNotifications,
    fetchAgenda: sessions_1._fetchAgenda,
    pinSession: sessions_1._pinSession,
    unpinSession: sessions_1._unpinSession,
    rateSession: sessions_1._rateSession,
    reserveSeat: sessions_1._reserveSeat,
    removeSeat: sessions_1._removeSeat,
    removeSeatNative: sessions_1._removeSeatNative,
    watchSession: sessions_1._watchSession,
    postSessionComment: sessions_1._postSessionComment,
    refetchSessionDiscussion: sessions_1._refetchSessionDiscussion,
    reportSessionAction: sessions_1._reportSessionAction,
    fetchMeetings: meetings_1._fetchMeetings,
    fetchArrangedMeetings: meetings_1._fetchArrangedMeetings,
    fetchLocation: meetings_1._fetchLocation,
    cancelMeeting: meetings_1._cancelMeeting,
    declineMeeting: meetings_1._declineMeeting,
    confirmMeeting: meetings_1._confirmMeeting,
    rateMeeting: meetings_1._rateMeeting,
    deliverMeeting: meetings_1._deliverMeeting,
    createMeeting: meetings_1._createMeeting,
    createArrangedMeeting: meetings_1._createArrangedMeeting,
    fetchZoomSignature: sessions_1._fetchZoomSignature,
    fetchPosts: posts_1._fetchPosts,
    fetchPostDetails: posts_1._fetchPostDetails,
    likePost: posts_1._likePost,
    unlikePost: posts_1._unlikePost,
    likeComment: posts_1._likeComment,
    unlikeComment: posts_1._unlikeComment,
    unlikeCommentNative: posts_1._unlikeCommentNative,
    unlikePostNative: posts_1._unlikePostNative,
    addComment: posts_1._addComment,
    addPost: posts_1._addPost,
    updatePost: posts_1._updatePost,
    fetchPages: pages_1._fetchPages,
    deletePost: posts_1._deletePost,
    deleteComment: posts_1._deleteComment,
    fetchEventTracks: tracks_1._fetchEventTracks,
    fetchCalendarEvents: calendar_1._fetchCalendarEvents,
    blockEvent: calendar_1._blockEvent,
    unblockEvent: calendar_1._unblockEvent,
    fetchAccounts: event_1._fetchAccounts,
    fetchEventsForAccount: event_1._fetchEventsForAccount,
    login: authentication_1._login,
    resetPassword: authentication_1._resetPassword,
    sendNewPassword: authentication_1._sendNewPassword,
    fetchAllPublicEvents: public_1._fetchAllPublicEvents,
    fetchPublicExhibitions: public_1._fetchPublicExhibitions,
    fetchPublicAgenda: public_1._fetchPublicAgenda,
    fetchPublicEventStatistics: public_1._fetchPublicEventStatistics,
    logout: authentication_1._logout,
    fetchZoomContent: event_1._fetchZoomContent,
    fetchYoutubeContent: event_1._fetchYoutubeContent,
    createStream: event_1._createStream,
    updateStream: event_1._updateStream,
    deleteStream: event_1._deleteStream,
    fetchAllExhibitions: event_1._fetchAllExhibitions,
    fetchMyExhibitions: event_1._fetchMyExhibitions,
    createExhibition: event_1._createExhibition,
    importExhibition: event_1._importExhibition,
    updateExhibition: event_1._updateExhibition,
    deleteExhibition: event_1._deleteExhibition,
    fetchSelectedEventSessions: sessions_1._fetchSelectedEventSessions,
    createSession: sessions_1._createSession,
    updateSession: sessions_1._updateSession,
    deleteSession: sessions_1._deleteSession,
    promoteSession: sessions_1._promoteSession,
    editMeeting: meetings_1._editMeeting,
    editMeetingNative: meetings_1._editMeetingNative,
    fetchEventMeetingsStatistics: meetings_1._fetchEventMeetingsStatistics,
    fetchPortfolios: event_1._fetchPortfolios,
    deletePortfolio: event_1._deletePortfolio,
    assignPortfolio: event_1._assignPortfolio,
    unassignPortfolio: event_1._unassignPortfolio,
    createPortfolio: event_1._createPortfolio,
    updatePortfolio: event_1._updatePortfolio,
    fetchPortfolioDetails: event_1._fetchPortfolioDetails,
    fetchPortfolioEvents: event_1._fetchPortfolioEvents,
    fetchBlogPages: event_1._fetchBlogPages,
    createBlogPage: event_1._createBlogPage,
    createAccountGroup: authentication_1._createAccountGroup,
    getPublicGroupDetails: public_1._getPublicGroupDetails,
    updatePortfolioBlogPage: event_1._updatePortfolioBlogPage,
    deletePortfolioBlogPage: event_1._deletePortfolioBlogPage,
    fetchColocatedEvents: authentication_1._fetchColocatedEvents,
    fetchFeeds: authentication_1._fetchFeeds,
    fetchPublicFeeds: public_1._fetchPublicFeeds,
    fetchPublicOffer: public_1._fetchPublicOffer,
    uploadPublicOfferPdf: public_1._uploadPublicOfferPdf,
    fetchFeed: authentication_1._fetchFeed,
    createFeed: authentication_1._createFeed,
    updateFeed: authentication_1._updateFeed,
    deleteFeed: authentication_1._deleteFeed,
    fetchColocatedEventDetails: authentication_1._fetchColocatedEventDetails,
    createColocatedEvents: authentication_1._createColocatedEvents,
    editColocatedEvents: authentication_1._editColocatedEvents,
    deleteColocatedEvents: authentication_1._deleteColocatedEvents,
    fetchMediaDirectories: event_1._fetchMediaDirectories,
    fetchMediaDirectoryFiles: event_1._fetchMediaDirectoryFiles,
    fetchMediaFileDetails: event_1._fetchMediaFileDetails,
    uploadFileToFolder: event_1._uploadFileToFolder,
    renameFolder: event_1._renameFolder,
    fetchAttendeeDetails: attendee_1._fetchAttendeeDetails,
    updatePackages: authentication_1._updatePackages,
    updateAttendeeImageNative: attendee_1._updateAttendeeImageNative,
    updateGlobalAttendeeImageNative: attendee_1._updateGlobalAttendeeImageNative,
    fetchEventsByAccount: authentication_1._fetchEventsByAccount,
    importTickets: event_1._importTickets,
    importEventWebsiteContent: event_1._importEventWebsiteContent,
    fetchPublicEventAdvertisement: event_1._fetchPublicEventAdvertisement,
    fetchColocatedAgenda: sessions_1._fetchColocatedAgenda,
    activateDataManagers: event_1._activateDataManagers,
    deactivateDataManagers: event_1._deactivateDataManagers,
    updateSessionTypes: authentication_1._updateSessionTypes,
    fetchSessionTypes: authentication_1._fetchSessionTypes,
    createOffer: event_1._createOffer,
    fetchOffers: event_1._fetchOffers,
    fetchOfferDetails: event_1._fetchOfferDetails,
    updateOffer: event_1._updateOffer,
    sendOffer: event_1._sendOffer,
    approveOffer: event_1._approveOffer,
    createTestimonial: event_1._createTestimonial,
    updateTestimonial: event_1._updateTestimonial,
    createStatistic: event_1._createStatistic,
    updateStatistic: event_1._updateStatistic,
    createKeyTopic: event_1._createKeyTopic,
    updateKeyTopic: event_1._updateKeyTopic,
    updateEventTargetGroups: event_1._updateEventTargetGroups,
    updateEventCitations: event_1._updateEventCitations,
    updateEventSurveys: event_1._updateEventSurveys,
    updateEventTickets: event_1._updateEventTickets,
    updateEventFaqs: event_1._updateEventFaqs,
    updateEventSpeakerAdverts: event_1._updateEventSpeakerAdverts,
    addPostNative: posts_1._addPostNative,
};
exports.useAPIContext = EventAPIContext_1.useAPIContext;
// Export menu constants
var types_1 = require("./api/event/types");
Object.defineProperty(exports, "MENU_ITEM_TYPES", { enumerable: true, get: function () { return types_1.MENU_ITEM_TYPES; } });
Object.defineProperty(exports, "MENU_ELEMENT_TYPES", { enumerable: true, get: function () { return types_1.MENU_ELEMENT_TYPES; } });
Object.defineProperty(exports, "MENU_ELEMENT_TYPE", { enumerable: true, get: function () { return types_1.MENU_ELEMENT_TYPE; } });
Object.defineProperty(exports, "DEFAULT_MENU_TYPES", { enumerable: true, get: function () { return types_1.DEFAULT_MENU_TYPES; } });
Object.defineProperty(exports, "DEFAULT_MENU_ITEM", { enumerable: true, get: function () { return types_1.DEFAULT_MENU_ITEM; } });
Object.defineProperty(exports, "MENU_ITEM_TYPE", { enumerable: true, get: function () { return types_1.MENU_ITEM_TYPE; } });
Object.defineProperty(exports, "MENU_ITEM_STYLING_LINK", { enumerable: true, get: function () { return types_1.MENU_ITEM_STYLING_LINK; } });
Object.defineProperty(exports, "MENU_ITEM_STYLING_BUTTON", { enumerable: true, get: function () { return types_1.MENU_ITEM_STYLING_BUTTON; } });
Object.defineProperty(exports, "MENU_ITEM_STYLING", { enumerable: true, get: function () { return types_1.MENU_ITEM_STYLING; } });
